import { render, staticRenderFns } from "./MessagesController.vue?vue&type=template&id=18e22a6a"
import script from "./MessagesController.vue?vue&type=script&lang=js"
export * from "./MessagesController.vue?vue&type=script&lang=js"
import style0 from "./MessagesController.vue?vue&type=style&index=0&id=18e22a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_@vue+compiler-sfc@_1ea54a5d08821f18e5f7625cad052d96/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports